<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value="date"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formated_data"
        @input="$emit('change', $event)"
        readonly
        v-bind="{ ...attrs, ...$attrs }"
        v-on="on"
        :error-messages="error_messages"
      ></v-text-field>
    </template>
    <v-date-picker
      :value="date"
      @input="$emit('change', $event)"
      no-title
      scrollable
      v-bind="$attrs"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
      <v-btn text color="primary" @click="$refs.menu.save(date)"> OK </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import DateTimeMixin from "@/mixins/DateTimeMixin";

export default {
  name: "date-picker",
  mixins: [DateTimeMixin],
  props: {
    date: {
      default: "",
      type: String,
    },
    error_messages: {
      default: () => [],
      type: Array,
    },
  },
  model: {
    prop: "date",
    event: "change",
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    formated_data: function () {
      if (this.date) return this.formatDate(this.date);
      else return "dd/mm/aaaa";
    },
  },
};
</script>